import { Component, AfterViewInit, OnDestroy, NgZone } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { InsaService, LocalizeService } from "../../insa-services";
import {
	KendoColumnDefinition,
	TransactionModel,
	ClientModel,
} from "../../insa-models";
import { appStateProvider } from "../../insa-providers";
import { appConfig } from "../../../insaweb.config";
import {
	customGroupHeader,
	SharedMethodsModule,
	CustomGridFilterModule,
} from "../../insa-custom-scripts";

@Component({
	template: `<div class="ptf gridResize">
		<div
			id="TransactionsGrid"
			(window:resize)="onResize($event)"
			class="transGrid-loading"
		></div>
		<grid-wizard
			[isVisible]="isGridWizardVisible"
			[gridName]="gridName"
			[metadataName]="metadataName"
			(onCloseModal)="closeGridWizard()"
			(onApplyGridSettings)="applyGridSettings($event)"
		></grid-wizard>
	</div>`,
})
export class TransactionsComponent implements AfterViewInit, OnDestroy {
	private gridName = "TransactionsGrid";
	private metadataName = "Transactions";
	private transSubscription;
	isGridWizardVisible: boolean = false;

	constructor(
		private _insaService: InsaService,
		private _appStateProvider: appStateProvider,
		private _localize: LocalizeService,
		private route: ActivatedRoute,
		private _zone: NgZone,
	) {
		let routeSnapshot = this.route.snapshot;

		if (routeSnapshot.queryParamMap.has("PartnerID")) {
			this._appStateProvider.selectedPartner = {
				value: Number.parseInt(routeSnapshot.queryParamMap.get("PartnerID")),
				text: "Self",
			};
		}
		if (routeSnapshot.queryParamMap.has("portfolios")) {
			var array = routeSnapshot.queryParamMap.get("portfolios").split(",");
			var intArray = new Array<any>();
			routeSnapshot.queryParamMap
				.get("portfolios")
				.split(",")
				.map((portf) => {
					intArray.push(Number.parseInt(portf));
				});
			this._appStateProvider.selectedPortfolios = intArray;
		}
		if (routeSnapshot.queryParamMap.has("fromDate")) {
			this._appStateProvider.startDate = new Date(
				routeSnapshot.queryParamMap.get("fromDate"),
			);
		}
		if (routeSnapshot.queryParamMap.has("toDate")) {
			this._appStateProvider.endDate = new Date(
				routeSnapshot.queryParamMap.get("toDate"),
			);
		}

		this.transSubscription =
			this._insaService.TransactionsChangedEvent.subscribe((transactions) => {
				this.refreshTransactions(transactions);
				//this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(transactions), transactions);
			});

		if (
			(this._appStateProvider.selectedPartners &&
				this._appStateProvider.selectedPartner.value != 0) ||
			(this._appStateProvider.selectedPortfolios &&
				this._appStateProvider.selectedPortfolios.length > 0)
		) {
			if (!this._appStateProvider.fetchingTransactions) {
				this._insaService.getTransactions();
			}
		}
		this.openGridWizard = this.openGridWizard.bind(this);
	}

	private exportToExcel() {
		let transGrid: any = $("#TransactionsGrid");
		if (transGrid !== undefined) {
			transGrid.getKendoGrid().saveAsExcel();
		}
	}

	private _transPdfBlobUrl: string = null;

	private openTransactionPdf(transIndex: number) {
		$("#trans-pdf-overlay").remove();
		if (this._transPdfBlobUrl) {
			URL.revokeObjectURL(this._transPdfBlobUrl);
			this._transPdfBlobUrl = null;
		}

		const isMobile =
			/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
			window.innerWidth < 768;
		const openLabel =
			this._localize.getLocalizedResource("Res4501") || "Open";

		const bodyStyle = isMobile
			? "flex:1;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:2rem;"
			: "flex:1;display:flex;align-items:center;justify-content:center;overflow:hidden;";

		const overlay = $(`
      <div id="trans-pdf-overlay" style="
        position:fixed;inset:0;z-index:9999;
        background:rgba(0,0,0,0.65);
        display:flex;align-items:center;justify-content:center;
        padding:1rem;">
        <div id="trans-pdf-modal" style="
          background:#fff;border-radius:0.5rem;
          box-shadow:0 8px 40px rgba(0,0,0,0.4);
          display:flex;flex-direction:column;
          width:90vw;max-width:${isMobile ? "480px" : "960px"};height:${isMobile ? "auto" : "88vh"};">
          <div id="trans-pdf-header" style="
            display:flex;align-items:center;justify-content:space-between;
            padding:0.75rem 1rem;border-bottom:1px solid #ddd;flex-shrink:0;">
            <span style="font-weight:600;font-size:0.95rem;">
              Transaction Confirmation #${transIndex}
            </span>
            <button id="trans-pdf-close" style="
              background:none;border:none;font-size:1.25rem;
              cursor:pointer;line-height:1;padding:0 0.25rem;color:#555;">✕</button>
          </div>
          <div id="trans-pdf-body" style="${bodyStyle}">
            <div id="trans-pdf-spinner" style="text-align:center;">
              <div style="
                width:2.5rem;height:2.5rem;border-radius:50%;
                border:3px solid #e0e0e0;border-top-color:#230078;
                animation:transPdfSpin 0.8s linear infinite;margin:0 auto 0.75rem;">
              </div>
              <span style="color:#888;font-size:0.875rem;">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    `);

		if (!document.getElementById("trans-pdf-spin-style")) {
			const style = document.createElement("style");
			style.id = "trans-pdf-spin-style";
			style.textContent =
				"@keyframes transPdfSpin { to { transform: rotate(360deg); } }";
			document.head.appendChild(style);
		}

		$("body").append(overlay);

		$("#trans-pdf-close, #trans-pdf-overlay").on("click", (e) => {
			if (
				e.target === document.getElementById("trans-pdf-overlay") ||
				$(e.target).is("#trans-pdf-close")
			) {
				this.closeTransactionPdf();
			}
		});

		this._insaService.getTransactionConfirmationReport(transIndex).subscribe(
			(data: string) => {
				if (!data) {
					this.showTransactionPdfError("No data returned from server.");
					return;
				}
				try {
					const byteChars = atob(data);
					const byteNumbers = new Uint8Array(byteChars.length);
					for (let i = 0; i < byteChars.length; i++) {
						byteNumbers[i] = byteChars.charCodeAt(i);
					}
					const blob = new Blob([byteNumbers], { type: "application/pdf" });
					this._transPdfBlobUrl = URL.createObjectURL(blob);
					if (isMobile) {
						$("#trans-pdf-spinner").replaceWith(`
							<div style="text-align:center;padding:1.5rem 2rem 2rem;">
								<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom:1rem;">
									<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
								</svg>
								<br>
								<a href="${this._transPdfBlobUrl}" download="transaction_${transIndex}.pdf"
								   style="display:inline-block;background:#230078;color:#fff;padding:0.6rem 2rem;border-radius:0.375rem;text-decoration:none;font-weight:600;font-size:0.95rem;">
									${openLabel}
								</a>
							</div>`);
					} else {
						$("#trans-pdf-spinner").replaceWith(
							`<iframe src="${this._transPdfBlobUrl}" style="width:100%;height:100%;border:none;border-radius:0 0 0.5rem 0.5rem;"></iframe>`,
						);
					}
				} catch (err) {
					this.showTransactionPdfError("Failed to render PDF.");
				}
			},
			() => this.showTransactionPdfError("Request failed."),
		);
	}

	private showTransactionPdfError(message: string) {
		$("#trans-pdf-spinner").html(
			`<div style="text-align:center;color:#c12a23;padding:2rem;">
        <div style="font-size:2rem;margin-bottom:0.5rem;">✕</div>
        <div style="font-size:0.9rem;">${message}</div>
       </div>`,
		);
	}

	private closeTransactionPdf() {
		$("#trans-pdf-overlay").remove();
		if (this._transPdfBlobUrl) {
			URL.revokeObjectURL(this._transPdfBlobUrl);
			this._transPdfBlobUrl = null;
		}
	}

	private refreshTransactions(transactions: TransactionModel[]) {
		kendo.ui.progress(
			$(".transGrid-loading"),
			this._appStateProvider.fetchingTransactions,
		);
		if (
			transactions !== undefined &&
			transactions !== null &&
			transactions.length > 0
		) {
			this.InitKendoTransactionsGrid(
				this.createTransactionGridColumnDefs(),
				transactions,
			);
		} else {
			this.InitKendoTransactionsGrid(
				this.createTransactionGridColumnDefs(),
				[],
			);
		}
	}

	private createTransactionGridColumnDefs() {
		let TransactionGridColumnDefs = new Array<KendoColumnDefinition>();
		let aggregateTemplate: string =
			"<div style='float: right'>#= (sum!==null) ? kendo.toString(sum, 'n2') : '' #</div>";

		//if(transactions!==undefined && transactions!==null) {
		//if (transactions[0].SecName !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"SecName",
				this._localize.getLocalizedResource("Res3516"),
				'#:(SecName!==null) ? SecName : "" #',
			),
		);
		//}
		//if (transactions[0].SecISIN !== undefined){
		//TransactionGridColumnDefs.push(new KendoColumnDefinition("SecISIN", this._localize.getLocalizedResource('Res960'),'#:(SecISIN!==null) ? SecISIN : "" #'));
		//}
		// if (transactions[0].TransDate !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"TransDate",
				this._localize.getLocalizedResource("Res704"),
				'#: (TransDate!==null)? kendo.toString(TransDate, "dd.MM.yyyy"): ""#',
			),
		);
		// }
		// if (transactions[0].ValueDate !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"ValueDate",
				this._localize.getLocalizedResource("Res707"),
				'#: (ValueDate!==null)? kendo.toString(ValueDate, "dd.MM.yyyy"): ""#',
			),
		);
		// }
		//if (transactions[0].TransTypeDescription !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"TransTypeDescription",
				this._localize.getLocalizedResource("Res3235"),
				'#: (TransTypeDescription!==null) ? TransTypeDescription : "" #',
			),
		);
		//}
		//if (transactions[0].QuantityWithoutCash !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"QuantityWithoutCash",
				this._localize.getLocalizedResource("Res688"),
				'#: (QuantityWithoutCash!==null) ? kendo.toString(QuantityWithoutCash, "n2"): "" #',
				"{0:#.##}",
				false,
				false,
			),
		);
		// }
		// if (transactions[0].Description !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"Description",
				this._localize.getLocalizedResource("Res542"),
				'#:(Description!==null) ? Description : ""#',
			),
		);
		//}
		// if (transactions[0].Price !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"Price",
				this._localize.getLocalizedResource("Res711"),
				'#: (Price!==null) ? kendo.toString(Price, "n2"): "" #',
				"{0:#.##}",
				false,
			),
		);
		//}
		//if (transactions[0].SecNumber !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"SecNumber",
				this._localize.getLocalizedResource("Res708"),
				'#:(SecNumber!==null) ? SecNumber : "" #',
			),
		);
		//}
		// 'Ref. Currency'
		//if (transactions[0].ClientRefCurr !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"ClientRefCurr",
				this._localize.getLocalizedResource("Res1033"),
				'#:(ClientRefCurr!==null) ? ClientRefCurr : "" #',
			),
		);
		// }
		// 'Amount Ref. Currency'
		//if (transactions[0].TransAmountRC !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"TransAmountRC",
				this._localize.getLocalizedResource("Res2480"),
				'#: (TransAmountRC!==null) ? kendo.toString(TransAmountRC, "n2"): "" #',
				"{0:#.##}",
				false,
				false,
				["sum"],
				aggregateTemplate,
				aggregateTemplate,
			),
		);
		//}
		// 'Sec. Currency'
		// if (transactions[0].SecurityCurrency !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"SecurityCurrency",
				this._localize.getLocalizedResource("Res724"),
				'#:(SecurityCurrency!==null) ? SecurityCurrency : "" #',
			),
		);
		//}
		// 'Amount Sec. Currency' --> Total (SC)
		//if (transactions[0].TransAmountSC !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"TransAmountSC",
				this._localize.getLocalizedResource("Res718"),
				'#: (TransAmountSC!==null) ? kendo.toString(TransAmountSC, "n2"): "" #',
				"{0:#.##}",
				false,
			),
		);
		//}
		//if (transactions[0].AccountCurrency !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"AccountCurrency",
				this._localize.getLocalizedResource("Res577"),
				'#: (AccountCurrency!==null) ? AccountCurrency : ""#',
			),
		);
		//}
		//  'Amount Account Currency' --> Total (AC)
		//if (transactions[0].TransAmountAC !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"TransAmountAC",
				this._localize.getLocalizedResource("Res720"),
				'#: (TransAmountAC!==null) ? kendo.toString(TransAmountAC, "n2"): ""#',
				"{0:#.##}",
				false,
			),
		);
		// }
		// if (transactions[0].AccountNumber !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"AccountNumber",
				this._localize.getLocalizedResource("Res702"),
				'#: (AccountNumber!==null) ? AccountNumber: "" #',
			),
		);
		// }
		// 'Deposit Number' --> Res1080 Custody Account
		//if (transactions[0].DepotNumber !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"DepotNumber",
				this._localize.getLocalizedResource("Res1080"),
				'#: (DepotNumber!==null) ? DepotNumber: "" #',
			),
		);
		//}
		//if (transactions[0].ClientNumber !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"ClientNumber",
				this._localize.getLocalizedResource("Res270"),
				'#: (ClientNumber!==null) ? ClientNumber: "" #',
			),
		);
		//}
		// if (transactions[0].Commision !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"Commision",
				this._localize.getLocalizedResource("Res1271"),
				'#: (Commision!==undefined && Commision!==null) ? kendo.toString(Commision, "n2"): "" #',
				"",
				false,
				false,
				["sum"],
				aggregateTemplate,
				aggregateTemplate,
			),
		);
		// }
		//if (transactions[0].StampDuty !== undefined){
		// TransactionGridColumnDefs.push(
		// 	new KendoColumnDefinition(
		// 		"StampDuty",
		// 		this._localize.getLocalizedResource("Res617"),
		// 		'#: (StampDuty!==undefined && StampDuty!==null) ? kendo.toString(StampDuty, "n2"): "" #',
		// 		"",
		// 		false,
		// 		false,
		// 		["sum"],
		// 		aggregateTemplate,
		// 		aggregateTemplate,
		// 	),
		// );
		//}
		// if (transactions[0].Expenses !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"Expenses",
				this._localize.getLocalizedResource("Res717"),
				'#: (Expenses!==undefined && Expenses!==null) ? kendo.toString(Expenses, "n2"): "" #',
				"",
				false,
				false,
				["sum"],
				aggregateTemplate,
				aggregateTemplate,
			),
		);
		//}
		//if (transactions[0].AccruedInterest !== undefined){
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"AccruedInterest",
				this._localize.getLocalizedResource("Res862"),
				'#: (AccruedInterest!==undefined && AccruedInterest!==null) ? kendo.toString(AccruedInterest, "n2"): "" #',
				"",
				false,
				false,
				["sum"],
				aggregateTemplate,
				aggregateTemplate,
			),
		);

		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"ForeignExpensesRef",
				this._localize.getLocalizedResource("Res713"),
				'#: (ForeignExpensesRef!==undefined && ForeignExpensesRef!==null) ? kendo.toString(ForeignExpensesRef, "n2"): "" #',
				"",
				false,
				false,
			),
		);
		TransactionGridColumnDefs.push(
			new KendoColumnDefinition(
				"StockExchangeTaxRef",
				this._localize.getLocalizedResource("Res716"),
				'#: (StockExchangeTaxRef!==undefined && StockExchangeTaxRef!==null) ? kendo.toString(StockExchangeTaxRef, "n2"): "" #',
				"",
				false,
				false,
			),
		);
		// TransactionGridColumnDefs.push(
		// 	new KendoColumnDefinition(
		// 		"EuroTaxRef",
		// 		this._localize.getLocalizedResource("Res431"),
		// 		'#: (EuroTaxRef!==undefined && EuroTaxRef!==null) ? kendo.toString(EuroTaxRef, "n2"): "" #',
		// 		"",
		// 		false,
		// 		false,
		// 	),
		// );
		// TransactionGridColumnDefs.push(
		// 	new KendoColumnDefinition(
		// 		"NonReclaimableTaxRef",
		// 		this._localize.getLocalizedResource("Res729"),
		// 		'#: (NonReclaimableTaxRef!==undefined && NonReclaimableTaxRef!==null) ? kendo.toString(NonReclaimableTaxRef, "n2"): "" #',
		// 		"",
		// 		false,
		// 		false,
		// 	),
		// );
		// TransactionGridColumnDefs.push(
		// 	new KendoColumnDefinition(
		// 		"ReclaimableTaxRef",
		// 		this._localize.getLocalizedResource("Res730"),
		// 		'#: (ReclaimableTaxRef!==undefined && ReclaimableTaxRef!==null) ? kendo.toString(ReclaimableTaxRef, "n2"): "" #',
		// 		"",
		// 		false,
		// 		false,
		// 	),
		// );

		this.setPropertiesForTransactionsGrid(TransactionGridColumnDefs);
		this.setGroupHeaderTemplate(TransactionGridColumnDefs);

		if (appConfig.printButtonVisible) {
			TransactionGridColumnDefs.push({
				title: "&nbsp;",
				width: 40,
				filterable: false,
				sortable: false,
				groupable: false,
				template:
					'<button class="trans-print-btn" title="Print" style="background:none;border:none;cursor:pointer;padding:2px;color:inherit;display:flex;align-items:center;justify-content:center;width:100%;">' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
					'<polyline points="6 9 6 2 18 2 18 9"/>' +
					'<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>' +
					'<rect x="6" y="14" width="12" height="8"/>' +
					"</svg>" +
					"</button>",
			} as any);
		}

		return TransactionGridColumnDefs;
		// }
	}

	private setGroupHeaderTemplate(arr: Array<KendoColumnDefinition>) {
		arr.forEach((element) => {
			element.groupHeaderTemplate =
				"#= getGroupInfo(aggregates,data, getKendoGrid('TransactionsGrid')) #";
		});
	}

	private setPropertiesForTransactionsGrid(kendoColumn) {
		let columnStyleLeftAlign: any = {
			style: "font-size:1rem;text-transform:none;",
		};
		let headerStyleLeftAlign: any = { style: "text-transform:none;" };
		let columnStyleRightAlign: any = {
			style: "text-align:right;font-size:1rem;text-transform:none;",
		};
		let headerStyleRightAlign: any = {
			style: "text-align:right;text-transform:none;",
		};

		for (let i = 0; i < kendoColumn.length; i++) {
			switch (kendoColumn[i].field) {
				case "TransAmountAC":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "ClientNumber":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "SecurityCurrency":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "ValueDate":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "TransDate":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "SecName":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "SecNumber":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "ClientRefCurr":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "QuantityWithoutCash":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "AccountCurrency":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "TransTypeDescription":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "TransAmountSC":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "TransAmountRC":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "Price":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "AccountNumber":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "DepotNumber":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "Description":
					kendoColumn[i].attributes = columnStyleLeftAlign;
					kendoColumn[i].headerAttributes = headerStyleLeftAlign;
					break;
				case "Commision":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "StampDuty":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "Expenses":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "AccruedInterest":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "ForeignExpensesRef":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "StockExchangeTaxRef":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "EuroTaxRef":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "NonReclaimableTaxRef":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				case "ReclaimableTaxRef":
					kendoColumn[i].attributes = columnStyleRightAlign;
					kendoColumn[i].headerAttributes = headerStyleRightAlign;
					kendoColumn[i].groupable = false;
					break;
				default:
					console.log("");
			}
		}

		SharedMethodsModule.fitColumnsToHeaderTitles(kendoColumn);
	}

	private hideColumnsDependingOnScreenSize(gridWidth) {
		let kendoTransGrid: kendo.ui.Grid =
			$("#TransactionsGrid").data("kendoGrid");
		let colVisibilityChanged: boolean = false;

		// Show all columns on both desktop and mobile;
		// only client-specific hidden columns remain hidden.
		kendoTransGrid.columns.forEach((col) => {
			if (!appConfig.clientSpecificColumnHidden.includes(col.field)) {
				if (col.hidden) colVisibilityChanged = true;
				kendoTransGrid.showColumn(col);
			} else {
				kendoTransGrid.hideColumn(col);
			}
		});

		if (colVisibilityChanged) {
			kendoTransGrid.refresh();
			$("#TransactionsGrid").find(".k-icon.k-i-collapse").trigger("click");
			colVisibilityChanged = false;
		}
	}

	openGridWizard() {
		this.isGridWizardVisible = true;
	}

	closeGridWizard() {
		this.isGridWizardVisible = false;
	}
	applyGridSettings(newOptions) {
		const kendoGrid = $("#" + this.gridName).data("kendoGrid");

		// add customCompare functions if necessary
		newOptions.columns = SharedMethodsModule.CustomizeGroupOrSortSettings(
			kendoGrid,
			newOptions.columns,
		);

		// append action collumns (edit/delete)
		const currOptions = kendoGrid.getOptions();
		const actionColumns = currOptions.columns.filter((col) => !col.field);
		if (actionColumns.length) {
			newOptions.columns.push(...actionColumns);
		}

		kendoGrid.setOptions(newOptions);
		setTimeout(() => {
			$("#custom-grid-wizard-toggle").off("click.gridWizard");
			$("#custom-grid-wizard-toggle").on("click.gridWizard", (e) => {
				e.preventDefault();
				this._zone.run(() => this.openGridWizard());
			});
		}, 100);
	}

	private onResize(event) {
		let transGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");
		this.hideColumnsDependingOnScreenSize(event.target.innerWidth);
		if (transGrid !== undefined) {
			transGrid.options.height = $(".gridResize").height();
			transGrid.resize();
		}
	}

	private InitKendoTransactionsGrid(columnDefs, griddata) {
		let dataSourceOptions: kendo.data.DataSourceOptions = {};
		dataSourceOptions.data = griddata;
		dataSourceOptions.group = [
			{
				field: "TransTypeDescription",
				aggregates: [
					{ field: "AccruedInterest", aggregate: "sum" },
					{ field: "StampDuty", aggregate: "sum" },
					{ field: "Expenses", aggregate: "sum" },
					{ field: "Commision", aggregate: "sum" },
					{ field: "TransAmountRC", aggregate: "sum" },
				],
			},
		];
		dataSourceOptions.aggregate = [
			{ field: "AccruedInterest", aggregate: "sum" },
			{ field: "StampDuty", aggregate: "sum" },
			{ field: "Expenses", aggregate: "sum" },
			{ field: "Commision", aggregate: "sum" },
			{ field: "TransAmountRC", aggregate: "sum" },
		];
		dataSourceOptions.schema = {
			model: {
				fields: {
					TransIndex: { type: "number" },
					SecName: { type: "string" },
					TransDate: { type: "date" },
					ValueDate: { type: "date" },
					TransTypeDescription: { type: "string" },
					QuantityWithoutCash: { type: "number" },
					Description: { type: "string" },
					Price: { type: "number" },
					SecNumber: { type: "string" },
					ClientRefCurr: { type: "string" },
					TransAmountRC: { type: "number" },
					TransAmountAC: { type: "number" },
					TransAmountSC: { type: "number" },
					SecurityCurrency: { type: "string" },
					AccountCurrency: { type: "string" },
					AccountNumber: { type: "string" },
					DepotNumber: { type: "string" },
					ClientNumber: { type: "string" },
					Commision: { type: "number" },
					StampDuty: { type: "number" },
					Expenses: { type: "number" },
					AccruedInterest: { type: "number" },
					ForeignExpensesRef: { type: "number" },
					StockExchangeTaxRef: { type: "number" },
					EuroTaxRef: { type: "number" },
					NonReclaimableTaxRef: { type: "number" },
					ReclaimableTaxRef: { type: "number" },
				},
			},
		};

		let dataSource: kendo.data.DataSource = new kendo.data.DataSource(
			dataSourceOptions,
		);
		let transGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");

		if (transGrid === undefined) {
			let transGridOptions: kendo.ui.GridOptions = {};
			transGridOptions.dataSource = dataSource;
			transGridOptions.excel = {
				fileName: "Transactions.xlsx",
				filterable: true,
				allPages: true,
			};
			transGridOptions.excelExport = function (e) {
				let sheet = e.workbook.sheets[0];
				for (let i = 0; i < sheet.rows.length; i++) {
					/* if(sheet.rows[i]["type"]==="header"){
                         for (var ci = 0; ci < sheet.rows[i].cells.length; ci++) {
                            if(sheet.rows[i].cells[ci].value === "Expenses") {
                             sheet.rows[i].cells[ci].value = <any>sheet.rows[i].cells[ci].value * 100; 
                            } 
                         }
                     }*/
					if (
						sheet.rows[i]["type"] === "group-header" ||
						sheet.rows[i]["type"] === "group-footer" ||
						sheet.rows[i]["type"] === "footer"
					) {
						sheet.rows[i].cells.reverse();
						for (var ci = 0; ci < sheet.rows[i].cells.length; ci++) {
							if (sheet.rows[i].cells[ci].value !== undefined) {
								sheet.rows[i].cells[ci].hAlign = "right";
								/*if(sheet.rows[i].cells[ci].value!== undefined && !isNaN(<any>sheet.rows[i].cells[ci].value))
                                {
                                   sheet.rows[i].cells[ci].hAlign = "right";
                                }*/
								sheet.rows[i].cells[ci].value = $(
									$.parseHTML(<any>sheet.rows[i].cells[ci].value),
								)[0].innerText;
							}
						}
					}
				}
			};
			transGridOptions.height = "100%";
			transGridOptions.sortable = true;
			transGridOptions.selectable = true;
			transGridOptions.reorderable = true;
			transGridOptions.scrollable = true;

			transGridOptions.filterable = {
				messages: {
					selectedItemsFormat: (() => {
						const res = this._localize.getLocalizedResource("Res569");
						if (!res) return "{0} stavki izabrano";

						return res.indexOf("{0}") !== -1 ? res : "{0} " + res;
					})(),
					info:
						this._localize.getLocalizedResource("Res2903") ||
						"Prikaži redove sa vrednošću koja:",
					filter: this._localize.getLocalizedResource("Res2902") || "Filtriraj",
					clear: this._localize.getLocalizedResource("Res2918") || "Očisti",
					and: this._localize.getLocalizedResource("Res2916") || "I",
					or: this._localize.getLocalizedResource("Res2917") || "Ili",
					selectValue:
						this._localize.getLocalizedResource("Res2920") ||
						"-Izaberi vrednost-",
				},
				operators: {
					string: {
						eq: this._localize.getLocalizedResource("Res2904") || "Jednako je",
						neq:
							this._localize.getLocalizedResource("Res2905") || "Nije jednako",
						isnull: this._localize.getLocalizedResource("Res2910") || "Je NULL",
						isnotnull:
							this._localize.getLocalizedResource("Res2911") || "Nije NULL",
						startswith:
							this._localize.getLocalizedResource("Res2906") || "Počinje sa",
						contains:
							this._localize.getLocalizedResource("Res2907") || "Sadrži",
					},
					number: {
						eq: this._localize.getLocalizedResource("Res2904") || "Jednako je",
						gt: this._localize.getLocalizedResource("Res495") || "Veće od",
						lt: this._localize.getLocalizedResource("Res496") || "Manje od",
						neq:
							this._localize.getLocalizedResource("Res2905") || "Nije jednako",
						isnull: this._localize.getLocalizedResource("Res2910") || "Je NULL",
						isnotnull:
							this._localize.getLocalizedResource("Res2911") || "Nije NULL",
					},
					date: {
						eq: this._localize.getLocalizedResource("Res2904") || "Jednako je",
						neq:
							this._localize.getLocalizedResource("Res2905") || "Nije jednako",
						isnull: this._localize.getLocalizedResource("Res2910") || "Je NULL",
						isnotnull:
							this._localize.getLocalizedResource("Res2911") || "Nije NULL",
					},
					enums: {
						eq: this._localize.getLocalizedResource("Res2904") || "Jednako je",
						neq:
							this._localize.getLocalizedResource("Res2905") || "Nije jednako",
						isnull: this._localize.getLocalizedResource("Res2910") || "Je NULL",
						isnotnull:
							this._localize.getLocalizedResource("Res2911") || "Nije NULL",
					},
				},
			};
			transGridOptions.columnMenu = {
				columns: false,
				messages: {
					sortAscending:
						this._localize.getLocalizedResource("Res2900") ||
						"Sortiraj rastuće",
					sortDescending:
						this._localize.getLocalizedResource("Res2901") ||
						"Sortiraj opadajuće",
					filter: this._localize.getLocalizedResource("Res2902") || "Filter",
				},
			};

			transGridOptions.toolbar = [
				"excel",
				"pdf",
				{
					template:
						"<button type='button' id='custom-grid-wizard-toggle' class='k-button k-button-icontext'><span class='k-icon custom-grid-wizard'></span>Grid Wizard</button>",
				},
			];
			transGridOptions.noRecords = {
				template: SharedMethodsModule.noDataTemplate(),
			};
			transGridOptions.groupable = {
				messages: {
					empty:
						this._localize.getLocalizedResource("Res2921") ||
						"Prevucite zaglavlje kolone i spustite ga ovde da biste grupisali po toj koloni",
				},
			};
			transGridOptions.group = function (e) {
				if (e.groups !== undefined && e.groups !== null) {
					let lastSavedGrouping = e.groups;
					localStorage.setItem(
						"transGridGrouping",
						JSON.stringify(lastSavedGrouping),
					);
				}
			};
			transGridOptions.sort = function (e) {
				if (e.sort !== undefined && e.sort !== null) {
					let lastSavedSorting = e.sort;
					localStorage.setItem(
						"transGridSorting",
						JSON.stringify(lastSavedSorting),
					);
				}
			};
			transGridOptions.pageable = false;
			transGridOptions.resizable = true;
			transGridOptions.columns = columnDefs;
			transGridOptions.columnReorder = customGroupHeader.gridColumnReorder;
			transGridOptions.dataBound = customGroupHeader.KendoGridDataBound;
			if (window.innerWidth > 768) {
				transGridOptions.filterMenuInit =
					CustomGridFilterModule.onFilterMenuInit;
			}

			SharedMethodsModule.saveGridOptionsOnChange(
				transGridOptions,
				this.gridName,
			);
			const savedOptions = SharedMethodsModule.getSavedGridOptions(
				columnDefs,
				this.gridName,
			);
			const combinedGridOptions = SharedMethodsModule.combineGridInitOptions(
				savedOptions,
				transGridOptions,
			);
			SharedMethodsModule.fitColumnsToHeaderTitles(combinedGridOptions.columns);
			$("#TransactionsGrid").kendoGrid(combinedGridOptions);
			transGrid = $("#TransactionsGrid").data("kendoGrid");
			$("#" + this.gridName).on("click", ".excelExportBtn", () => {
				this.exportToExcel();
			});
			$("#" + this.gridName).on("click", ".trans-print-btn", (e) => {
				e.stopPropagation();
				const row = $(e.currentTarget).closest("tr");
				const grid = $("#TransactionsGrid").data("kendoGrid");
				const dataItem = grid.dataItem(row);
				if (!dataItem || dataItem["TransIndex"] == null) {
					console.warn(
						"trans-print-btn: TransIndex not found on row data",
						dataItem,
					);
					return;
				}
				this.openTransactionPdf(dataItem["TransIndex"]);
			});
			if (savedOptions && savedOptions.dataSource) {
				$("#" + this.gridName)
					.data("kendoGrid")
					.dataSource.group(savedOptions.dataSource.group);
				$("#" + this.gridName)
					.data("kendoGrid")
					.dataSource.sort(savedOptions.dataSource.sort);
			}
		} else {
			$("#TransactionsGrid").data("kendoGrid").setDataSource(dataSource);
		}

		transGrid.thead
			.find("[data-field=QuantityWithoutCash]>.k-header-column-menu")
			.remove();
		transGrid.thead.find("[data-field=Price]>.k-header-column-menu").remove();
		transGrid.thead
			.find("[data-field=TransAmountAC]>.k-header-column-menu")
			.remove();
		transGrid.thead
			.find("[data-field=TransAmountSC]>.k-header-column-menu")
			.remove();
		transGrid.thead
			.find("[data-field=Commision]>.k-header-column-menu")
			.remove();
		transGrid.thead
			.find("[data-field=Expenses]>.k-header-column-menu")
			.remove();
		transGrid.thead
			.find("[data-field=StampDuty]>.k-header-column-menu")
			.remove();
		transGrid.thead
			.find("[data-field=AccruedInterest]>.k-header-column-menu")
			.remove();
		if (appConfig.sortTransactionsByDefault)
			transGrid.thead.find("[data-field=TransDate] >.k-link").trigger("click");
		SharedMethodsModule.loadGridGroupingAndSorting("TransactionsGrid");

		setTimeout(() => {
			$("#custom-grid-wizard-toggle").off("click.gridWizard");
			$("#custom-grid-wizard-toggle").on("click.gridWizard", (e) => {
				e.preventDefault();
				this._zone.run(() => this.openGridWizard());
			});
		}, 10);
	}

	ngAfterViewInit() {
		kendo.ui.progress(
			$(".transGrid-loading"),
			this._appStateProvider.fetchingTransactions,
		);
		if (
			this._insaService.transactions !== undefined &&
			this._insaService.transactions !== null
		) {
			this.refreshTransactions(this._insaService.transactions);
			//this.InitKendoTransactionsGrid(this.createTransactionGridColumnDefs(this._insaService.transactions), this._insaService.transactions);
			this.hideColumnsDependingOnScreenSize(window.innerWidth);
		}
	}

	ngOnDestroy() {
		this.transSubscription.unsubscribe();
		this.closeTransactionPdf();
	}
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-grids/transactions.component.ts